import { z } from 'zod';
// API response
export const apiClientResp = z.object({
    clientMessage: z.string(),
    success: z.boolean().optional(),
});
//# sourceMappingURL=error.js.map